// Cart Stuff

function attachCartItemListeners() {
	const cartItemElements = document.querySelectorAll(
		"[data-cart-item-adjustment]"
	);

	cartItemElements.forEach(function (element) {
		const decreaseButton = element.querySelector("[data-cart-item-decrease]");
		const increaseButton = element.querySelector("[data-cart-item-increase]");
		const quantityInput = element.querySelector("[data-cart-item-input]");
		const lineItemId = element.getAttribute("data-line-item-id");

		const debouncedTriggerChange = debounce(function () {
			quantityInput.dispatchEvent(new Event("change"));
		}, 320);

		decreaseButton.addEventListener("click", function () {
			const currentQuantity = parseInt(quantityInput.value);
			if (currentQuantity > 1) {
				quantityInput.value = currentQuantity - 1;
				debouncedTriggerChange();
			}
		});

		increaseButton.addEventListener("click", function () {
			const currentQuantity = parseInt(quantityInput.value);
			quantityInput.value = currentQuantity + 1;
			debouncedTriggerChange();
		});

		quantityInput.addEventListener("change", function () {
			const newQuantity = parseInt(quantityInput.value);
			updateCartItem(lineItemId, newQuantity);
		});
	});
}

// Debounce function
function debounce(func, delay) {
	let timeoutId;
	return function () {
		const context = this;
		clearTimeout(timeoutId);
		timeoutId = setTimeout(function () {
			func.apply(context);
		}, delay);
	};
}

function updateCartItem(lineItemId, quantity) {
	fetch("/cart/change.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			id: lineItemId,
			quantity: quantity,
		}),
	})
		.then(function (response) {
			return response.json();
		})
		.then(function (updatedCart) {
			// Find the section ID dynamically
			const sectionId = findSectionId();
			// Re-render the cart section using the Shopify section rendering API
			rerenderCartSection(sectionId);
		})
		.catch(function (error) {
			console.error("Error updating cart:", error);
		});
}

function findSectionId() {
	const cartSection = document
		.querySelector("[data-cart-item-adjustment]")
		.closest("[data-section-id]");
	if (cartSection) {
		return cartSection.getAttribute("data-section-id");
	}
	return null;
}

function rerenderCartSection(sectionId) {
	if (sectionId) {
		const cartSection = document.querySelector(`[data-section-id="${sectionId}"]`);
		cartSection.classList.add("is-loading"); // Add the loading class
		fetch(`/?section_id=${sectionId}`)
			.then(function (response) {
				return response.text();
			})
			.then(function (sectionHTML) {
				cartSection.innerHTML = sectionHTML;
				cartSection.classList.remove("is-loading"); // Remove the loading class
				attachCartItemListeners(); // Re-attach event listeners after re-rendering
			})
			.catch(function (error) {
				cartSection.classList.remove("is-loading"); // Remove the loading class
				console.error("Error re-rendering cart section:", error);
			});
	} else {
		console.error("Section ID not found");
	}
}

function updateItemFromCart(updates) {
  console.log(updates);
	fetch("/cart/update.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({updates}),
	})
		.then((response) => response.json())
		.then((updatedCart) => {
			const sectionId = findSectionId();
			rerenderCartSection(sectionId);
		})
		.catch((error) => {
			console.error("Error adding item to cart:", error);
		});
}

document.addEventListener("DOMContentLoaded", function () {
	attachCartItemListeners();


});

